export interface SubDomainRedirectionConfig {
  defaultSubDomain?: string;
}
